export const SOMETHING_WRONG = 'Something went wrong';
export const ERROR_401_USER_NOT_FOUND = 'User not found, please try again';
export const ERROR_401 = 'Unauthorized!';
export const SIGN_OUT = 'You are signed out! Please login again.';
export const VIDEO_ERROR = 'Error converting video, please re-upload video!';
